import {selectArr} from "../utils/utils";
import Swiper from 'swiper/bundle';

export class ImageTextCarousel {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.carouselContainer = selectArr("[data-image-text-carousel]");
  }

  render() {
    this.statsCarousel();
  }

  statsCarousel = () => {
      this.carouselContainer.map(cc => {
          new Swiper(cc, {
              slidesPerView: 1,
              spaceBetween: 0,
              autoplay: {
                  delay: 3000,
              },
              scrollbar: {
                  el: '.swiper-scrollbar',
                  draggable: true,
              },
              centeredSlides: true,
              navigation: {
                  nextEl: "[data-image-text-carousel] .swiper-button-next",
                  prevEl: "[data-image-text-carousel] .swiper-button-prev",
              },
          });
      })
  };
}
